export class GetVirtualAccountRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  categoryCode: string | null = null;
  merchantCode: string | null = null;
  provider_code: string | null = null;
  // type: string = '1'; // value 1 is virtualAccount type
  status: string | null = null;
  bank: string | null = null;
  created_from: string | null = null;
  created_to: string | null = null;
}

export class CreateVirtualAccountParams {
  id: string = '';
  name: string = '';
  user: string = '';
  password: string = '';
  secret_code: string = '';
  base_url: string = '';
  method: string = '';
  inq_param: string = '';
  pay_param: string = '';
  adv_param: string = '';
  reversal_param: string = '';
  inq_url: string = '';
  pay_url: string = '';
  adv_url: string = '';
  reversal_url: string = '';
}

export class UpdateVirtualAccountRequestParams extends CreateVirtualAccountParams {
  oldPassword?: string;
}

export interface VirtualAccountData {
  id: string;
  name: string;
  user: string;
  password: string;
  secret_code: string;
  base_url: string;
  method: string;
  inq_param: string;
  pay_param: string;
  adv_param: string;
  reversal_param: string;
  inq_url: string;
  pay_url: string;
  adv_url: string;
  reversal_url: string;
  created_at: string;
  updated_at: string;
}

export interface GetVirtualAccountResponse {
  code: number;
  message: string;
  data: VirtualAccountData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetVirtualAccountByIdResponse {
  code: number;
  message: string;
  data: VirtualAccountData;
}

export interface DeleteVirtualAccountByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
